import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BsReceipt } from "react-icons/bs";
import { Outlet } from "react-router-dom";
import ngLogo from "../../assets/images/ng-logo.svg";
import { appStore } from "../../stores/appStore";

import { BetSlip } from "../BetSlip/BetSlip";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import Menu from "../Menu/Menu";
import { StyledbetSlipBtn, StyledbetSlipBtnCount } from "../Footer/FooterStyle";

const AppContainer = ({ children, screen }) => {

  const { t } = useTranslation("General");
  const [btnDisabled, setBtnDisabled] = useState(true);

  // fetching data from appStore
  const { betSlipSelections, setShowBetSlip, generalConfig } =
    appStore((state) => ({
      betSlipSelections: state.betSlipSelections,
      setShowBetSlip: state.setShowBetSlip,
      generalConfig: state.generalConfig
    }));

  const betSlipBtn = () => {
    window.scrollTo(0, 0);
    window.parent.postMessage({ action: "scrolltotop" }, "*");
    setShowBetSlip(true);
  };

  // if betslipSelection is 0 then betslip button disable
  useEffect(() => {
    setBtnDisabled(betSlipSelections.length === 0 ? true : false);
  }, [betSlipSelections]);

  return (
    <React.Fragment>
      <div className="container bg-white p-0 position-relative overflow-hidden">
        <Header />
        <div className="pt-2 pb-0 position-relative">
          <Menu />
        </div>
        <div
          className="pt-2 pb-0 position-relative"
        >
          {screen}
        </div>

        <div className={`mx-2 my-1 ${generalConfig.showBetslipButton ? 'd-block' : 'd-none'}`}>
          <StyledbetSlipBtn selected={!btnDisabled}
            onClick={betSlipBtn}
            disabled={btnDisabled}
            className={`position-relative border border-secondary rounded-3 betslipBtn w-100
              ${btnDisabled
                ? "text-secondary bg-white"
                : "text-white bg-secondary"}
           ` }
          >
            <StyledbetSlipBtnCount selected={betSlipSelections.length !== 0}
              className="position-absolute betslip-badge p-1 translate-middle badge rounded-pill bg-white text-secondary border border-secondary">
              {betSlipSelections.length}
            </StyledbetSlipBtnCount>
            <BsReceipt size="17px" />
            {" "}
            &nbsp;{t("V-betslip")}
          </StyledbetSlipBtn>
        </div>

        <div className="d-flex justify-content-center align-items-center p-2 powered-by-logo text-muted bg-light">
          <div className="mt-1">
            {t("Powered by")}&nbsp;&nbsp;
            <img src={ngLogo} className="App-logo" alt="logo" height={"24px"} />
          </div>
        </div>
        <Footer />
        <BetSlip />
      </div>
    </React.Fragment>
  );
};
export default AppContainer;